// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__zC7M-","loader":"Loading_loader__+KH1f"};